import { useStore, useStoreMap } from 'effector-react/compat'
import { $cities } from '@entities/cities/model'

export const useCities = () => useStore($cities)
export const useCityById = (cityId: number) =>
    useStoreMap({
        store: $cities,
        keys: [cityId],
        fn: (cities, [id]) => cities?.find((x) => x.id === id)
    })
